import type {ActionListing} from '@github-ui/marketplace-common'
import {OverviewHeader} from '../OverviewHeader'
import {About} from './About'
import {Tags} from './Tags'
import type {Repository, DelistActionData, ReleaseData} from '../../types'
import {ListingBreadcrumbs} from '../ListingBreadcrumbs'
import {DelistButton} from './DelistButton'
import {ReleaseBanner} from './ReleaseBanner'
import {Button, Stack} from '@primer/react'
import {VersionButton} from './VersionButton'

interface HeaderProps {
  action: ActionListing
  repository: Repository
  delistActionData: DelistActionData
  releaseData: ReleaseData
}

export function Header(props: HeaderProps) {
  const {action, repository, delistActionData, releaseData} = props
  const {selectedRelease, latestRelease} = releaseData

  return (
    <OverviewHeader
      listing={action}
      breadcrumbs={<ListingBreadcrumbs listing={action} />}
      banner={<ReleaseBanner selectedRelease={selectedRelease} latestRelease={latestRelease} action={action} />}
      delistButton={<DelistButton action={action} delistActionData={delistActionData} />}
      listingDetails={<About action={action} repository={repository} />}
      additonalDetails={<Tags tags={action.categories} />}
      callToAction={
        <Stack gap={'condensed'} direction={'horizontal'} className={'width-full width-md-auto'}>
          <Button className={'width-full'}>Stars Button</Button>
          <VersionButton releaseData={releaseData} action={action} repository={repository} />
        </Stack>
      }
    />
  )
}

try{ Header.displayName ||= 'Header' } catch {}